
import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "./AddInvoiceComponent.module.scss";
import PriceInvoiceTable from "components/Tables/PriceInvoiceTable";
function InvoiceView(props) {
  return (
    <>
      <div className={cn(styles.flex_item1)}>
          <div className={cn(styles.flex1)}>
            <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
              {"Price"}
            </h2>
          {/* -- */}
                            
            <div className={cn(styles.group, styles.group_layout, styles.boxShadow)}>
          
              <div className={cn(styles.flex3, styles.flex3_layout, styles.mg0)}>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>  
                    <PriceInvoiceTable/>
                  </div>
                  <div className={cn(styles.flex3_spacer)} />
                </div>
{/* //------- */}
            </div>
            </div>
         </div>
        <div>
    </div>
</div>  
    </>
  );
}


export default function Invoice(props) {
  return (
    <>
      <Master opts={props} screen={InvoiceView} showStatus={false} />
    </>
  );
}

Invoice.inStorybook = true;
